export enum IconType {
    Success,
    Failure,
    Profit,
    Rug
}